// @flow

import * as React from 'react';

export const AuthContext = React.createContext(
  {}, // default value
);

type Props = {
  isLoggedIn: boolean,
  children: React.Node,
};

export const AuthConsumer = AuthContext.Consumer;

export class AuthProvider extends React.PureComponent<Props> {
  render() {
    return (
      <AuthContext.Provider
        value={{
          isLoggedIn: this.props.isLoggedIn,
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}
